import React from "react";
import "../styles/CareerTips.css";

const CareerTips = () => {
  return (
    <div className="career-tips-page">
      <h1>📚 Career Tips & Resources</h1>
      <p className="intro-text">
        Unlock your full career potential with expert guidance, resume-building tips, interview strategies, and upskilling resources.
      </p>

      {/* Featured Articles Section */}
      <section className="career-section">
        <h2>📖 Featured Career Articles</h2>
        <div className="article-cards">
          <div className="article-card">
            <h3>How to Build a Job-Winning Resume?</h3>
            <p>Learn the essential elements that make a resume stand out.</p>
            <a href="/resumetips" className="read-more">Read More →</a>
          </div>
          <div className="article-card">
            <h3>Common Interview Mistakes to Avoid</h3>
            <p>Know the top mistakes candidates make in interviews and how to avoid them.</p>
            <a href="/mockinterviews" className="read-more">Read More →</a>
          </div>
          <div className="article-card">
            <h3>Top 10 High-Paying Tech Skills in 2024</h3>
            <p>Explore the most in-demand skills that can boost your salary.</p>
            <a href="/highpayingskills" className="read-more">Read More →</a>
          </div>
        </div>
      </section>

      {/* Resume & Interview Tips Section */}
      <section className="career-section">
        <h2>📝 Resume & Interview Tips</h2>
        <ul className="tips-list">
          <li>✅ Keep your resume concise (1-2 pages max).</li>
          <li>✅ Customize your resume for each job application.</li>
          <li>✅ Use action words like "Developed," "Managed," and "Implemented."</li>
          <li>✅ Practice STAR method for interview answers (Situation, Task, Action, Result).</li>
          <li>✅ Research the company before your interview.</li>
        </ul>
      </section>

      {/* Free & Paid Upskilling Courses */}
      <section className="career-section">
        <h2>🚀 Upskilling Resources</h2>
        <p>Boost your knowledge with these top courses:</p>
        <div className="course-cards">
          <div className="course-card">
            <h3>FreeCodeCamp – Web Development</h3>
            <p>Learn HTML, CSS, JavaScript, and more for free.</p>
            <a href="https://www.freecodecamp.org/" target="_blank" rel="noopener noreferrer">Explore Course →</a>
          </div>
          <div className="course-card">
            <h3>Coursera – Data Science & AI</h3>
            <p>Get certified in AI & ML from top universities.</p>
            <a href="https://www.coursera.org/" target="_blank" rel="noopener noreferrer">Explore Course →</a>
          </div>
          <div className="course-card">
            <h3>Udemy – Mastering JavaScript</h3>
            <p>Advanced JavaScript concepts for developers.</p>
            <a href="https://www.udemy.com/" target="_blank" rel="noopener noreferrer">Explore Course →</a>
          </div>
        </div>
      </section>

      {/* CTA for Personalized Career Advice */}
      <section className="career-advice">
        <h2>💡 Need Personalized Career Advice?</h2>
        <p>Get expert guidance tailored to your skills and job goals.</p>
        <button className="advice-btn">Get Free Consultation</button>
      </section>
    </div>
  );
};

export default CareerTips;
